<mat-progress-bar
  *ngIf="isLoading | async"
  class="api-progress"
  mode="query"
></mat-progress-bar>
